export const Colors = {
  BLUE: '#4287f5',
  ORANGE: '#ebb031',
  GRAY: '#666',
  GREEN: '#00990f',
};
